<template lang="pug">
    div.periods
        // Periods filter
        filter-component(
            :name="$t('fields.showDataBy')"
            :value="period"
            :items="$t('statistics.periodsMember')"
            :callbackFunction="filterCallback"
        )
</template>

<script>
    import { mapFields } from 'vuex-map-fields';
    import { mapActions } from 'vuex';
    import FilterSelection from '~components/FilterSelection';

    export default {
        components: {
            FilterComponent: FilterSelection
        },
        computed: {
            ...mapFields('statistics', ['period'])
        },
        methods: {
            ...mapActions('statistics', ['updateRange']),
            filterCallback(e) {
                this.period = e.value;
                if (e.value === 'range') return;
                this.updateRange(this.id);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .periods
        max-width: 300px
</style>
